import { type RagStatus } from '../ui/rag-badge';

/**
 * Màu RAG cho SVG/canvas — docs/frontend-guide.md §4.
 *
 * Chart nhận **biến CSS**, không nhận mã màu: token đổi theo chế độ sáng/tối ở
 * `styles/index.css`, và một hex viết cứng trong component chart sẽ đúng ở một
 * chế độ, sai ở chế độ kia. Nó cũng là chỗ duy nhất cần sửa khi bảng màu đổi.
 */
export const RAG_VAR: Record<RagStatus, string> = {
  red: 'var(--color-rag-red)',
  amber: 'var(--color-rag-amber)',
  green: 'var(--color-rag-green)',
  unknown: 'var(--color-rag-unknown)',
};

/**
 * Màu cho ba nhóm trạng thái công việc.
 *
 * `todo` dùng token `unknown` chứ không phải một màu xám tự chọn: "chưa bắt
 * đầu" đúng nghĩa là chưa có gì để kết luận, và dùng lại token có sẵn giữ cho
 * bảng màu của cả hệ thống chỉ có một nguồn.
 */
export const FLOW_VAR = {
  todo: RAG_VAR.unknown,
  inProgress: RAG_VAR.amber,
  done: RAG_VAR.green,
} as const;

/**
 * Bốn trạng thái, không phải ba: thiếu `unknown` thì "chưa đủ dữ liệu" bị vẽ
 * thành xanh, và báo cáo nói dối mà không ai biết.
 */
export function ragOfRatio(
  value: number | null,
  thresholds = { green: 0.9, amber: 0.6 },
): RagStatus {
  if (value === null || Number.isNaN(value)) return 'unknown';
  if (value >= thresholds.green) return 'green';
  if (value >= thresholds.amber) return 'amber';
  return 'red';
}
